import './Cards.css'

import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { useGenerateImageByContext } from '../../hooks/apiHooks/personasHooks'
import { useMentorsState } from '../../hooks/storeHooks/useMentors'
import type { Title } from '../../pages/SearchPage/useMentorsSearch'
import { MentorBase } from '../../types/mentor'
import { CardLayout } from './CardLayout'

export default function TitleCard({ title, mentor, id, imageUrl }: Title) {
  const {
    mutate: generateImage,
    data: imgData,
    isPending: isImageGenerating,
  } = useGenerateImageByContext()

  const [isMentorGenerating, setIsMentorGenerating] = useState(false)

  const { setSelectedMentor } = useMentorsState()

  useEffect(() => {
    if (mentor && Object.keys(mentor).length === 0) {
      setIsMentorGenerating(true)
      return
    }

    if (isImageGenerating) {
      setIsMentorGenerating(true)
      return
    }

    if (mentor?.mentorType === 'GENERATED') {
      setIsMentorGenerating(true)
      return
    }

    if (
      (!mentor?.mentorType || mentor?.mentorType !== 'GENERATED') &&
      !isImageGenerating
    ) {
      setIsMentorGenerating(false)
    }
  }, [mentor?.mentorType, isImageGenerating])

  const handleCardClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (mentor?.mentorType === 'GENERATED' || !mentor?.mentorId || !id) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    setSelectedMentor(mentor as MentorBase)
  }

  useEffect(() => {
    if (id && !imageUrl) {
      generateImage(id)
    }
  }, [generateImage, id, imageUrl])

  const handleCopyLink = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    void navigator.clipboard.writeText(
      `${window.location.origin}/${mentor?.slug}?start=true&context=${id}`,
    )
    toast.success('Copied to clipboard')
  }

  return (
    <CardLayout
      mentor={mentor}
      id={id}
      handleCardClick={handleCardClick}
      handleCopyLink={handleCopyLink}
      title={title}
      imageUrl={imageUrl || imgData?.url || ''}
      isMentorGenerating={isMentorGenerating}
    />
  )
}
